export default {
  "base_url": "https://app.elint.co.za/",
  "base_api_url": "https://app.elint.co.za/api/",
  "api_version": "1.0",
  "url": "/mobile"
}



// WEBPACK FOOTER //
// ./src/env.js